import { ComponentType, ReactElement } from 'react';
import { PaloThemeProvider } from '@synergy/theme-palo';

/**
 * Renders a wizard step under the PALO theme so its tables and controls pick up
 * the dense metrics. The stepper talks to steps through props only, so wrapping
 * keeps the step contract intact — no copy of the step page needed.
 */
export const withPaloTheme = <P extends object>(Step: ComponentType<P>): ((props: P) => ReactElement) => {
    const Wrapped = (props: P): ReactElement => (
        <PaloThemeProvider>
            <Step {...props} />
        </PaloThemeProvider>
    );
    Wrapped.displayName = `withPaloTheme(${Step.displayName || Step.name || 'Step'})`;

    return Wrapped;
};
